import { secondaryColor } from "@themes/defaultThemeProps";

const imageUploadStyle = {
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    "&>*": {
      margin: "0 12px"
    }
  },
};

export default imageUploadStyle;
